import { SelectField } from "@/app/features/reports/components/select-field"
import { useCallback, useMemo } from "react"
import { useFormContext } from "react-hook-form"
import { CustomFieldProps } from '../custom-fields-container'
type CustomSelectFieldProps = CustomFieldProps & {
  options: { id: string; displayName: string }[]
  selectionType: 'single' | 'multiple';
  allowAdd?: boolean;
  onAddOption?: (fieldId: string, displayName: string) => Promise<{ success: boolean, field_id: string, data: any }>;
}

export function CustomSelectField({
  control,
  name,
  label,
  description,
  showDescription,
  info,
  required,
  placeholder,
  options,
  selectionType,
  isValid,
  allowAdd = false,
  showFormMessage = false,
  onAddOption,
}: CustomSelectFieldProps) {

  const customFieldOptions = useMemo(() => {
    return options.map((option) => ({ value: option.id, label: option.displayName }))
  }, [options])

  const { trigger, setValue } = useFormContext();

  const handleOnChange = useCallback((value: any) => {
    console.debug('handleOnChange', name, value);
    setValue(name, value, { shouldValidate: true, shouldDirty: true, shouldTouch: true });
    trigger();
  }, [setValue, trigger, name]);

  const handleOnCreateOption = useCallback(async (value: string) => {
    console.debug('handleOnCreateOption', name, value);
    return await onAddOption?.(name, value);
  }, [onAddOption, name]);

  // if (selectionType === 'multiple') {
  return (
    <SelectField
      control={control}
      //@ts-expect-error
      name={name}
      label={label}
      info={info}
      isValid={isValid}
      options={customFieldOptions}
      required={required}
      placeholder={placeholder}
      disabled={false}
      description={description}
      className="w-full"
      multiple={selectionType === 'multiple'}
      allowAdd={allowAdd}
      onSelect={handleOnChange}
      onCreateOption={handleOnCreateOption}
    />
  )

}

